import React, { useState } from "react";
import { InputField } from "../../components/form/InputField";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { showToast } from "../../utils/toast";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import Image from "../../components/form/Image";
import {
  extractAuthFromLoginResponse,
  fetchData,
  postRequest,
} from "../../hooks/services/services";
import { useTranslation } from "react-i18next";
import LoginWithGoogle from "../../SSOLogin/loginWithGoogle";
import "../../common.css";
import { loginFailure, loginSuccess, setUnreadNotificationCount } from "../../redux/actions/authActions";
import { useSelector, useDispatch } from "react-redux";
// import { jwtDecode } from 'jwt-decode';
import CommonModal from "../modal/CommonModal";
import SignUpButton from "../../components/modal/Signupbutton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import LoginWithApple from "../../SSOLogin/loginWithApple";


const Login = () => {
  const { t } = useTranslation("login");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const profileCompleted = auth?.profile_completed;
  const [loading, setLoading] = useState(false);
  const [modelOpen, setModelOpen] = useState(false);
  const [modelType, setModalType] = useState(false);
  const [headerContent, setHeaderContent] = useState();
  const [isBussnessSelected, setIsBussnessSelected] = useState(false);
  const [loginTypeValue, setLoginTypeValue] = useState("Athlete");
  const [signUpTypeValue, setSignUpTypeValue] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleTypeSelect = (type) => {
    setSignUpTypeValue(type);
  };

  const schema = Yup.object().shape({
    email: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email format"
      )
      .email("Invalid email format")
      .required("Email is required"),
    password: Yup.string().required("Field is required"),
  });

  const getDefaultValues = () => {
    return {};
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: getDefaultValues(),
  });

  const forgotPassword = (event) => {
    setModelOpen(true);
    setModalType({ name: "forgotPassword", type: loginTypeValue });
    setHeaderContent("Forgot password?");
  };

const onSubmit = async (data) => {
  setLoading(true);
  try {
    const payload = {
      email: data?.email,
      password: data?.password,
      type: loginTypeValue,
    };

    const response = await postRequest("api/v1/sessions/sign_in", payload);
    const responseData = await response.json();

    if (response.ok) {
      const { token, id } = extractAuthFromLoginResponse(response, responseData);
      const profile_completed = responseData?.profile_completed;
      const active_subscription = responseData?.active_subscription;

      if (!token) {
        throw new Error("Login succeeded but auth token was not received.");
      }

      dispatch(
        loginSuccess({
          token,
          id,
          user_type: loginTypeValue,
          profile_completed,
        })
      );

      const redirectData = localStorage.getItem("redirectData");
      let redirectPath = null;

      if (redirectData) {
        const { path, userType } = JSON.parse(redirectData);
        if (userType === loginTypeValue) {
          redirectPath = path;
        }
        localStorage.removeItem("redirectData");
      }

      if (redirectPath) {
        navigate(redirectPath);
      } else if (loginTypeValue === "Contractor") {
        if (profile_completed && active_subscription) {
          navigate("/contractor/profile");
        } else {
          navigate("/plan");
        }
      } else if (loginTypeValue === "Athlete") {
        navigate("/athlete/myroadmap");
      } else {
        navigate("/business/info");
      }

      showToast(responseData?.message, "success");

      try {
        const notifRes = await fetchData("api/v1/notifications/unread_count");
        if (notifRes) {
          const notifData = await notifRes.json();
          dispatch(setUnreadNotificationCount(notifData?.unread_count || 0));
        }
      } catch (notifError) {
        console.warn("Failed to fetch unread notification count:", notifError);
      }
    }
  } catch (error) {
    showToast(error.message, "error");
    dispatch(loginFailure(error.message || "Login failed."));
  } finally {
    setLoading(false);
  }
};


  const onHandleChage = async (event) => {
    try {
      setLoginTypeValue(event.target.value);
      if (event.target.value === "Business") {
        setIsBussnessSelected(true);
      } else {
        setIsBussnessSelected(false);
      }
    } catch (error) {
      showToast(error.message, "error");
    }
  };

  return (
    <div>
      <div class="login-container">
        <div class="left-section">
          <div class="content-wrapper">
            <a href="https://www.globalllife.com/" target="_self" rel="noopener noreferrer">
              <Image
                src="images/logo.svg"
                alt="Globall Life Logo"
                className="logo"
              />
            </a>
            <div class="loginMain">
              <div class="loginContent">
                <h3>
                  <Image src="images/thumbs_up.svg" alt="Thumbs up icon" />{" "}
                  {/* Plan. Practice. Execute. */}
                  Plan After Sport Success
                </h3>
                <p>Your next chapter starts with the right game plan.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="right-section">
          <div class="form-wrapper">
            <h2>Welcome to the PASS App</h2>
            <p>Log in to your account</p>
            <form onSubmit={handleSubmit(onSubmit)} class="mt-5">
              <div class="row g-3">
                <div class="col-md-12">
                  <select
                    class="dropdown"
                    id="loginType"
                    name="loginType"
                    value={loginTypeValue}
                    onChange={(e) => onHandleChage(e)}
                  >
                    <option value={"Athlete"}>Athlete</option>
                    <option value={"Business"}>Business</option>
                    <option value={"Contractor"}>Service Provider</option>
                  </select>
                </div>
                <div class="col-md-12">
                  <div>
                    <InputField
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Email Address or Mobile *"
                      register={register}
                      error={errors?.email?.message}
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div>
                    <InputField
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password *"
                      register={register}
                      error={errors?.password?.message}
                    >
                      <button
                        type="button"
                        className="passwordToggle"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <FontAwesomeIcon
                          icon={showPassword ? faEyeSlash : faEye}
                        />
                      </button>
                    </InputField>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="options">
                    <label class="switch">
                      <input type="checkbox" />
                      <span class="sliders round"></span>
                    </label>
                    <a onClick={() => forgotPassword()} class="recover-link">
                      Recover Password
                    </a>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                class="transparent_btn mt-4 mb-4"
                disabled={loading}
                style={{ backgroundColor: loading ? "rgba(0, 0, 0, 0.1)" : "" }}
              >
                {loading && loading ? (
                  <div className="btn-loader"></div>
                ) : (
                  "Log In"
                )}
              </button>
            </form>

            {!isBussnessSelected && (
              <div>
                <div class="continue">
                  <p class="divider">Or continue with</p>
                </div>

                <div class="social-buttons">
                  <div className="google-button">
                    <LoginWithGoogle loginTypeValue={loginTypeValue}></LoginWithGoogle>
                  </div>
                  {/* <LoginWithApple loginTypeValue={loginTypeValue}/> */}
                </div>
                <SignUpButton onSelectType={handleTypeSelect} />
              </div>
            )}
          </div>
        </div>
      </div>
      <CommonModal
        modalType={modelType}
        modelOpen={modelOpen}
        setModelOpen={setModelOpen}
        headerContent={headerContent}
        setModalType={setModalType}
        // bodyContent={
        //   "We’ve sent a verification code to abiola@globalllife.com Enter the code below to reset your password."
        // }
      ></CommonModal>
    </div>
  );
};

export default Login;
